import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { OnboardingInput } from '@eriko/validation';
import { getOrgSettings } from '../api/org';
import { updateOnboarding } from '../api/auth';
import i18n from '../i18n';

export function useOrgSettings() {
  return useQuery({
    queryKey: ['org', 'settings'],
    queryFn: getOrgSettings,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdatePreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: OnboardingInput) => updateOnboarding(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['org', 'settings'] });
      toast.success(i18n.t('preferences.toastUpdated', { ns: 'settings' }));
    },
    onError: (err: Error) => {
      toast.error(err.message || i18n.t('preferences.toastError', { ns: 'settings' }));
    },
  });
}
